import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '@/logic/break/BreakUtils';

registerCollisionAnimation('INK_SPLAT', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const count = 12;
  ctx.fillStyle = determineColor(0, 1);
  ctx.globalAlpha = 1 - progress;
  for (let i = 0; i < count; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = (i / count) * Math.PI * 2;
    const len = e.radius + rnd * 100 * Math.pow(progress, 0.5);
    const width = 10 * (1 - progress) * rnd;

    ctx.beginPath();
    ctx.moveTo(e.pos.x, e.pos.y);
    ctx.lineTo(e.pos.x + Math.cos(angle) * len, e.pos.y + Math.sin(angle) * len);
    ctx.lineWidth = width;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.stroke();

    // End blob
    ctx.beginPath(); ctx.arc(e.pos.x + Math.cos(angle) * len, e.pos.y + Math.sin(angle) * len, width, 0, Math.PI * 2); ctx.fill();
  }
});
